import React from 'react';
import { Badge, Stack, Text } from '@mantine/core';
import { getSurveyTypeLabel } from '../../constants/surveyTypes';

type SurveyTypeLabelCellProps = {
    surveyType?: string | null;
    label?: string | null;
};

export function SurveyTypeLabelCell({
    surveyType,
    label,
}: SurveyTypeLabelCellProps) {
    const typeLabel = getSurveyTypeLabel(surveyType);
    const trimmedLabel = label?.trim();
    const showLabel =
        !!trimmedLabel &&
        trimmedLabel.toLowerCase() !== typeLabel?.toLowerCase();

    if (!typeLabel && !trimmedLabel) {
        return (
            <Text size="sm" c="dimmed">
                -
            </Text>
        );
    }

    return (
        <Stack gap={4}>
            {typeLabel ? (
                <Badge color="blue" variant="light" size="sm" className="w-fit">
                    {typeLabel}
                </Badge>
            ) : null}
            {showLabel ? (
                <Text size="sm" fw={500} lineClamp={2} title={trimmedLabel}>
                    {trimmedLabel}
                </Text>
            ) : null}
        </Stack>
    );
}
